/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Mobile slider navigation dots functionality
  function initMobileSliderDots() {
    const sliders = document.querySelectorAll('.grid--mobile-slider[data-has-navigation-dots="true"]');
    
    sliders.forEach(slider => {
      const dots = slider.closest('.grid-outer, .collection-list-outer').querySelectorAll('.mobile-slider-dot');
      const items = slider.querySelectorAll('.grid-item');
      
      if (!dots.length || !items.length) return;
      
      const itemsPerPage = 2; // Show 2 items per page
      
      // Update active dot based on scroll position
      function updateActiveDot() {
        const scrollLeft = slider.scrollLeft;
        const itemWidth = items[0].offsetWidth + (parseInt(getComputedStyle(items[0]).marginRight) || 0);
        const currentPage = Math.round(scrollLeft / (itemWidth * itemsPerPage));
        
        dots.forEach((dot, index) => {
          dot.classList.toggle('active', index === currentPage);
        });
      }
      
      // Handle dot click
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const itemWidth = items[0].offsetWidth + (parseInt(getComputedStyle(items[0]).marginRight) || 0);
          const scrollPosition = index * itemWidth * itemsPerPage;
          
          slider.scrollTo({
            left: scrollPosition,
            behavior: 'smooth'
          });
        });
      });
      
      // Listen for scroll events
      let scrollTimeout;
      slider.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updateActiveDot, 50);
      });
      
      // Initialize on load
      updateActiveDot();
    });
  }
  
  // Initialize on DOM content loaded
  document.addEventListener('DOMContentLoaded', initMobileSliderDots);
  
  // Reinitialize when sections are loaded (for theme editor)
  document.addEventListener('shopify:section:load', initMobileSliderDots);

  //
  // move reviews attributes to the side panel start
  //
  function moveReviewAttributes() {
    document.querySelectorAll('.oke-w-review-main .oke-w-review-attributes').forEach(attr => {
      const expandContent = attr.closest('.oke-w-review').querySelector('.oke-w-review-side-expandContent');
      expandContent?.insertAdjacentElement('afterend', attr);
    });
  }

  // Initial load
  setTimeout(moveReviewAttributes, 1500);

  // Watch for new reviews after "show more" is clicked
  const observer = new MutationObserver(() => {
    setTimeout(moveReviewAttributes, 100);
  });
  
  // Start observing the reviews container
  const reviewsContainer = document.querySelector('.oke-w-reviews, .okendo-reviews, [class*="review"]');
  if (reviewsContainer) {
    observer.observe(reviewsContainer, { childList: true, subtree: true });
  }

  //
  // move reviews attributes to the side panel end
  //

  //
  // Header tabbed navigation functionality
  //  
  
  function initTabNavigation() {
    const tabContainers = document.querySelectorAll('.menu__item--tabs, .mobile-menu__tabs');
    
    tabContainers.forEach(container => {
      // Find the appropriate scope for panels
      const panelScope = container.closest('.header__dropdown') || container.closest('.drawer__content') || container.parentElement;
      
      // Only initialize if this container has the tabs structure
      const tabs = container.querySelectorAll('.menu__tab');
      const panels = panelScope.querySelectorAll('.menu__tab-panel');
      
      if (tabs.length === 0 || panels.length === 0) {
        return; // Skip if no tabs or panels found
      }
      
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          
          // Remove active class from all tabs and panels in this container only
          tabs.forEach(t => t.classList.remove('menu__tab--active'));
          panels.forEach(p => p.classList.remove('menu__tab-panel--active'));
          
          // Add active class to clicked tab and corresponding panel
          tab.classList.add('menu__tab--active');
          if (panels[index]) {
            panels[index].classList.add('menu__tab-panel--active');
          }
        });
      });
    });
  }

  // Initialize tab navigation on page load
  document.addEventListener('DOMContentLoaded', initTabNavigation);
  
  // Re-initialize after any dynamic content changes
  document.addEventListener('shopify:section:load', initTabNavigation);

  //
  // Simple header visibility tracking for Headroom.js
  //
  function updateHeaderVisibilityVar() {
    const header = document.querySelector('#site-header');
    if (!header) return;
    
    const isHidden = header.classList.contains('headroom--unpinned');
    const isAtTop = header.classList.contains('headroom--top');
    
    if (isHidden || isAtTop) {
      document.documentElement.style.setProperty('--HEADER-VISIBLE-HEIGHT', '0px');
    } else {
      const headerHeight = header.offsetHeight;
      document.documentElement.style.setProperty('--HEADER-VISIBLE-HEIGHT', `calc(${headerHeight}px + var(--outer))`);
    }
  }

  // Update on DOM load and periodically check for class changes
  document.addEventListener('DOMContentLoaded', () => {
    updateHeaderVisibilityVar();
    
    // Simple observer to watch for class changes on header
    const header = document.querySelector('#site-header');
    if (header) {
      const observer = new MutationObserver(updateHeaderVisibilityVar);
      observer.observe(header, { attributes: true, attributeFilter: ['class'] });
    }
    
    // Update cart-bar price on variant/plan change
    initCartBarPriceSync();
  });

  function initCartBarPriceSync() {
    const cartBar = document.querySelector('#cart-bar');
    if (!cartBar) return;

    const cartBarButton = cartBar.querySelector('button.product__submit__add');
    const priceElement = cartBar.querySelector('.btn__price');
    if (!cartBarButton || !priceElement) return;

    // Get initial state and update price
    const productForm = document.querySelector('product-form');
    if (productForm && productForm.productForm) {
      const formState = productForm.productForm.getFormState();
      const variant = formState.variant;
      if (variant) {
        updateCartBarPrice(priceElement, cartBarButton, variant, formState);
      }
    }

    // Listen to variant change events from product-form
    document.addEventListener('theme:variant:change', (e) => {
      const variant = e.detail?.variant;
      if (!variant) return;

      const productForm = document.querySelector('product-form');
      if (!productForm || !productForm.productForm) return;

      const formState = productForm.productForm.getFormState();
      updateCartBarPrice(priceElement, cartBarButton, variant, formState);
    });
  }

  function updateCartBarPrice(priceElement, button, variant, formState) {
    if (!window.theme?.settings?.visualDiscountEnable) {
      // Visual discount disabled - show regular price
      const price = variant.price;
      const comparePrice = variant.compare_at_price;
      
      if (comparePrice && comparePrice > price) {
        priceElement.innerHTML = `${window.theme.formatMoney(price, theme.moneyFormat)} <s>${window.theme.formatMoney(comparePrice, theme.moneyFormat)}</s>`;
      } else {
        priceElement.textContent = window.theme.formatMoney(price, theme.moneyFormat);
      }
      
      button.disabled = !variant.available;
      return;
    }

    // Check if should apply visual discount (no subscription)
    const shouldApplyDiscount = !formState.plan;
    const discountPercent = window.theme.settings.visualDiscountPercentage || 30;

    if (shouldApplyDiscount) {
      // Apply visual discount
      const discountedPrice = Math.round(variant.price * (100 - discountPercent) / 100);
      priceElement.innerHTML = `<span class="price--sale">${window.theme.formatMoney(discountedPrice, theme.moneyFormat)}</span> <span class="price--compare">${window.theme.formatMoney(variant.price, theme.moneyFormat)}</span>`;
    } else {
      // Subscription selected - show regular price or subscription price
      const price = formState.plan?.allocation?.price || variant.price;
      const comparePrice = formState.plan?.allocation?.compare_at_price || variant.compare_at_price;
      
      if (comparePrice && comparePrice > price) {
        priceElement.innerHTML = `${window.theme.formatMoney(price, theme.moneyFormat)} <s>${window.theme.formatMoney(comparePrice, theme.moneyFormat)}</s>`;
      } else {
        priceElement.textContent = window.theme.formatMoney(price, theme.moneyFormat);
      }
    }

    button.disabled = !variant.available;
  }

  //
  // Inject custom styles into Recharge Widget Shadow DOM
  //
  function injectRechargeWidgetStyles() {
    const WIDGET_TAG = 'recharge-subscription-widget';
    
    // Define your custom CSS here
    const customStyles = `
      .rc-price {
        color: #212121 !important;
      }
      .rc-price.strike-through {
        color: red !important;
      }
    `;

    function applyStyles(widget) {
      if (!widget.shadowRoot) return;

      const ensureStyles = () => {
        if (!widget.shadowRoot.querySelector('#custom-recharge-styles')) {
          const style = document.createElement('style');
          style.id = 'custom-recharge-styles';
          style.textContent = customStyles;
          widget.shadowRoot.appendChild(style);
        }
      };

      // Apply immediately
      ensureStyles();

      // Watch for changes in the shadow root (in case innerHTML is wiped)
      const observer = new MutationObserver(() => {
        ensureStyles();
      });

      observer.observe(widget.shadowRoot, { childList: true });
    }

    // 1. Handle existing widgets
    customElements.whenDefined(WIDGET_TAG).then(() => {
      document.querySelectorAll(WIDGET_TAG).forEach(applyStyles);
    });

    // 2. Watch for new widgets
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.tagName.toLowerCase() === WIDGET_TAG) {
            customElements.whenDefined(WIDGET_TAG).then(() => applyStyles(node));
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Initialize Recharge widget styling
  document.addEventListener('DOMContentLoaded', injectRechargeWidgetStyles);

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
